import { render, staticRenderFns } from "./Elaboration.vue?vue&type=template&id=4a2f42c6&scoped=true"
import script from "./Elaboration.vue?vue&type=script&lang=js"
export * from "./Elaboration.vue?vue&type=script&lang=js"
import style0 from "./Elaboration.vue?vue&type=style&index=0&id=4a2f42c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f42c6",
  null
  
)

export default component.exports